import { FormattedMessage } from "react-intl";
import { ActivityIndicator } from "react-native";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { useEventOccurrence } from "views/EventDetails/hooks";
import { Card, Flex } from "components/styles";
import useOrderSession from "hooks/useOrderSession";
import OrderSessionButton from "components/atoms/OrderSessionButton";
import { useOrderContext } from "providers/OrderProvider/hooks";

import * as Styled from "./styles";
import { useBillingForm } from "./hooks";
import BillingForm from "./partials/BillingForm";

const Billing: React.FC = () => {
  const { eventOccurrence, loading } = useEventOccurrence(true);
  const { loading: submitting } = useOrderContext();
  const { expireAt, expireIn, isExpired, onReset } = useOrderSession();
  const billingForm = useBillingForm();

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%" overflow="auto">
      <Card>
        <BillingForm {...billingForm}>
          <Styled.Actions>
            <Button
              $fullW
              type="submit"
              $mode="tertiary"
              size="large"
              disabled={isExpired || submitting}
            >
              <FormattedMessage defaultMessage="Next" />
            </Button>
            {expireAt && (
              <OrderSessionButton
                {...{
                  expireIn,
                  isExpired,
                  onReset,
                }}
              />
            )}
          </Styled.Actions>
        </BillingForm>
      </Card>
    </Flex>
  );
};

export default Billing;
